import { NavigationFailureType } from 'vue-router'

export const filteroutNavigationDuplicated = (err) => {
	// Ignore the vuex err regarding  navigating to the page they are already on.
	if (err.name !== 'NavigationDuplicated') {
		// But print any other errors to the console
		// eslint-disable-next-line
		console.error(err)
	}
}

export const filteroutRedirected = (err) => {
	// Ignore the vuex err regarding  navigating to the page they are already on.
	if (err.type !== NavigationFailureType.redirected) {
		throw err
	}
}
